/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Type of resource usage being metered and billed across different cloud providers. Each dimension represents a specific billable resource type, such as compute instances, storage volumes, database services, or data transfer. Used to categorize costs by service type for detailed analysis and chargeback reporting. 
*/
export enum MeteringDimension {
  AwsEc2MeteringDimension = 'AWS_EC2_METERING_DIMENSION',
  AwsRdsMeteringDimension = 'AWS_RDS_METERING_DIMENSION',
  AwsS3MeteringDimension = 'AWS_S3_METERING_DIMENSION',
  AwsS3DlsgMeteringDimension = 'AWS_S3_DLSG_METERING_DIMENSION',
  AwsDynamoDbMeteringDimension = 'AWS_DYNAMO_DB_METERING_DIMENSION',
  AwsEksMeteringDimension = 'AWS_EKS_METERING_DIMENSION',
  AzureVirtualMachineMeteringDimension = 'AZURE_VIRTUAL_MACHINE_METERING_DIMENSION',
  AzureStorageAccountMeteringDimension = 'AZURE_STORAGE_ACCOUNT_METERING_DIMENSION',
  AzureSqlVirtualMachineMeteringDimension = 'AZURE_SQL_VIRTUAL_MACHINE_METERING_DIMENSION',
  GcpVmInstanceMeteringDimension = 'GCP_VM_INSTANCE_METERING_DIMENSION',
  GcpCloudStorageMeteringDimension = 'GCP_CLOUD_STORAGE_METERING_DIMENSION',
  GcpCloudSqlPostgresSqlMeteringDimension = 'GCP_CLOUD_SQL_POSTGRES_SQL_METERING_DIMENSION',
  GcpCloudSqlMysqlMeteringDimension = 'GCP_CLOUD_SQL_MYSQL_METERING_DIMENSION',
  GcpCloudSqlSqlServerMeteringDimension = 'GCP_CLOUD_SQL_SQL_SERVER_METERING_DIMENSION',
  DataTransferMeteringDimension = 'DATA_TRANSFER_METERING_DIMENSION',
  CrossCloudDataTransferMeteringDimension = 'CROSS_CLOUD_DATA_TRANSFER_METERING_DIMENSION',
  AwsEc2ToAzureVaultMeteringDimension = 'AWS_EC2_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsS3ToAzureVaultMeteringDimension = 'AWS_S3_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsRdsToAzureVaultMeteringDimension = 'AWS_RDS_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsDynamoDbToAzureVaultMeteringDimension = 'AWS_DYNAMO_DB_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsEksToAzureVaultMeteringDimension = 'AWS_EKS_TO_AZURE_VAULT_METERING_DIMENSION',
  AzureVirtualMachineToAwsVaultMeteringDimension = 'AZURE_VIRTUAL_MACHINE_TO_AWS_VAULT_METERING_DIMENSION',
  AzureStorageAccountToAwsVaultMeteringDimension = 'AZURE_STORAGE_ACCOUNT_TO_AWS_VAULT_METERING_DIMENSION',
  AzureSqlVirtualMachineToAwsVaultMeteringDimension = 'AZURE_SQL_VIRTUAL_MACHINE_TO_AWS_VAULT_METERING_DIMENSION',
  RansomwareProtectedStorageMeteringDimension = 'RANSOMWARE_PROTECTED_STORAGE_METERING_DIMENSION'
}
